import React, { useState, useEffect } from "react";
import { Sparkles, X, ExternalLink, MessageSquareHeart } from "lucide-react";
import { clinic } from "../mock";

export default function LuciaButton() {
  const [open, setOpen] = useState(false);
  const [hint, setHint] = useState(false);

  useEffect(() => {
    const openHandler = () => setOpen(true);
    window.addEventListener("open-lucia", openHandler);
    const t = setTimeout(() => setHint(true), 4500);
    const t2 = setTimeout(() => setHint(false), 12000);
    return () => {
      window.removeEventListener("open-lucia", openHandler);
      clearTimeout(t);
      clearTimeout(t2);
    };
  }, []);

  return (
    <>
      {/* Chat panel */}
      <div
        className={`fixed z-[60] transition-all duration-300 origin-bottom-left
          bottom-24 left-4 sm:left-6
          ${open ? "opacity-100 scale-100 pointer-events-auto" : "opacity-0 scale-95 pointer-events-none"}`}
      >
        <div className="w-[92vw] sm:w-[390px] h-[70vh] sm:h-[600px] max-h-[640px] rounded-3xl overflow-hidden shadow-2xl shadow-blue-950/40 border border-white/20 bg-white flex flex-col">
          {/* Header */}
          <div className="hero-gradient text-white px-4 py-3 flex items-center gap-3">
            <span className="w-10 h-10 rounded-full bg-white/15 border border-white/25 grid place-items-center">
              <MessageSquareHeart size={20} className="text-blue-100" />
            </span>
            <div className="flex-1 leading-tight">
              <div className="font-display font-bold text-sm flex items-center gap-1.5">
                LucIA <Sparkles size={13} className="text-blue-200" />
              </div>
              <div className="text-[11px] text-blue-100/75">Tu guía inteligente en salud visual</div>
            </div>
            <a
              href={clinic.luciaUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Abrir en pestaña completa"
              className="w-8 h-8 rounded-full grid place-items-center hover:bg-white/15 transition-colors"
            >
              <ExternalLink size={16} />
            </a>
            <button
              onClick={() => setOpen(false)}
              aria-label="Cerrar chat"
              className="w-8 h-8 rounded-full grid place-items-center hover:bg-white/15 transition-colors"
            >
              <X size={18} />
            </button>
          </div>

          {/* Embedded LucIA app */}
          <iframe
            title="Asistente LucIA"
            src={clinic.luciaUrl}
            className="flex-1 w-full border-0 bg-white"
            allow="microphone; clipboard-write"
          />

          <div className="text-[10px] text-slate-400 text-center py-1.5 border-t border-slate-100 bg-slate-50">
            LucIA es informativa y no reemplaza una consulta médica presencial.
          </div>
        </div>
      </div>

      {/* Floating launcher */}
      <div className="fixed z-[60] bottom-6 left-4 sm:left-6 flex items-center gap-3">
        <button
          onClick={() => setOpen((o) => !o)}
          aria-label="Habla con LucIA"
          className="group relative flex items-center gap-2.5 rounded-full pl-2.5 pr-5 py-2.5 text-white font-semibold shadow-xl hero-gradient border border-white/15 hover:scale-[1.03] transition-transform"
        >
          <span className="w-9 h-9 rounded-full bg-white/15 grid place-items-center">
            {open ? <X size={18} className="text-blue-100" /> : <Sparkles size={18} className="text-blue-100" />}
          </span>
          <span className="text-sm">{open ? "Cerrar" : "Habla con LucIA"}</span>
        </button>

        {hint && !open && (
          <div className="hidden sm:flex items-center gap-2 bg-white text-[#0b2545] text-sm font-medium px-4 py-2.5 rounded-2xl shadow-lg border border-slate-100 animate-floaty">
            ¿Dudas sobre tu visión? Pregúntame
            <button onClick={() => setHint(false)} className="text-slate-400 hover:text-slate-600">
              <X size={14} />
            </button>
          </div>
        )}
      </div>
    </>
  );
}
